import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});
// const head = { "Content-Type": "multipart/form-data" };

// const instance2 = axios.create({
//   baseURL: "http://localhost:3333",
//   headers: { ...authHeader(), ...head },
// });
class TambonService {
  // newPass(id, req) {
  //   return instance.put("/users/new", req, {
  //     params: {
  //       id: id,
  //     },
  //   });
  // }
  //   updateUserprofile(id, req) {
  //     return instance.put("/users/profile/" + id, req);
  //   }
  //   getUserprofile(id) {
  //     return instance.get("/users/profile/" + id);
  //   }
  //   deleteTimereg(id) {
  //     return instance.delete("/timereg/" + id);
  //   }
  //   getTimereglist() {
  //     return instance.get("/timereg");
  //   }
  get(body) {
    return instance.post("/getprov", body);
  }
  getByname(body) {
    return instance.post("/getbyname", body);
  }
}

export default new TambonService();
